import script from "./FileInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileInput.vue?vue&type=script&lang=ts&setup=true"

import "./FileInput.vue?vue&type=style&index=0&id=4727b7ff&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4727b7ff"]])

export default __exports__